<template>
  <div class="personal">
    <!-- 显示 -->
    <div class="main_top">
      <el-card class="m_t_left">
        <h3>
          <i class="el-icon-s-data"></i>业务统计
        </h3>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/a.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>全部</h4>
            <p style="color:#2da1f9">{{ staticsData.count1 || 0 }}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/b.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>未入仓</h4>
            <p style="color:#67ca29">{{ staticsData.count2 || 0 }}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/c.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>未发货</h4>
            <p style="color:#fda005">{{ staticsData.count3 || 0 }}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/d.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已发货</h4>
            <p style="color:#3ec6c4">{{ staticsData.count4 || 0 }}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/e.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已清关</h4>
            <p style="color:#e07070">{{ staticsData.count5 || 0 }}</p>
          </div>
        </div>
        <div class="m_box">
          <div class="m-img">
            <img src="../assets/f.png" alt />
          </div>
          <div class="m_box_cent">
            <h4>已签收</h4>
            <p style="color:#4977fc">{{ staticsData.count6 || 0 }}</p>
          </div>
        </div>
      </el-card>
      <el-card class="m_t_center">
        <h3><i class="el-icon-user"/>账号信息</h3>
        <div class="m_title">
          <img src="../assets/person.png" />
          <h2>{{ userData.username || '加载中...' }}</h2>
        </div>
        <div>
          <el-button size="mini" @click="toAccount">修改资料</el-button>
          <el-button size="mini" @click="toPassword">修改密码</el-button>
          <el-button size="mini" @click="autheDialog">实名认证</el-button>
          <el-button 
            size="mini" 
            @click="openWxDialog"
            v-if="userData.nickname">
            微信解绑
          </el-button>
          <el-button size="mini" @click="openWxDialog" v-else>微信绑定</el-button>
        </div>
        <ul class="m_btn">
          <li>
            <b>用户编号:</b>
            <span>{{ userData.userCode || '-' }}</span>
          </li>
          <li>
            <b>微信昵称:</b>
            <span v-if="userData.nickname" style="color:#409EFF;">{{ userData.nickname }}</span>
            <span v-else style="color:red;">未绑定微信</span>
          </li>
          <li>
            <b>账号状态:</b>
            <span v-if="userData.statusTxt === '正常'">{{ userData.statusTxt }}</span>
            <span v-else style="color:red;">{{ userData.statusTxt || '-' }}</span>
          </li>
          <li>
            <b>会员级别:</b>
            <span>vip</span>
          </li>
          <li>
            <b>业务员:</b>
            <span>{{ userData.sellerName || '-' }}</span>
          </li>
          <li>
            <b>实名认证:</b>
            <span v-if="userData.userAuthe === '1'" style="color:#409EFF;">已认证</span>
            <span v-else style="color:red;">未认证</span>
          </li>
        </ul>
      </el-card>
      <el-card class="m_t_right" style="margin-right:0">
        <h3><i class="el-icon-money"/>用户余额</h3>
        <ul class="m-btn">
          <li>
            <b>信用额度:</b>
            <span>{{ balanceData.credit || 0 }} 元</span>
          </li>
          <li>
            <b>剩余额度:</b>
            <span v-if="balanceData.remainingCredit >= 0">{{ balanceData.remainingCredit }} 元</span>
            <span v-else style="color:red;">{{ balanceData.remainingCredit }} 元</span>
          </li>
          <li>
            <b>总消费:</b>
            <span>{{ balanceData.totalConsumption || 0 }} 元</span>
          </li>
          <li>
            <b>待付款:</b>
            <span v-if="balanceData.obligations > 0" style="color:#F56C6C">{{ balanceData.obligations }} 元</span>
            <span v-else>{{ balanceData.obligations || 0 }} 元</span>
          </li>
        </ul>
      </el-card>
    </div>
    <div class="main_btn">
      <el-card class="m_b_left">
        <h3><i class="el-icon-warning-outline"/>问题件</h3>
        <el-table
          :data="abnormalData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column fixed label="运单号">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="问题件" prop="problemRemark"></el-table-column>
          <el-table-column label="订单日期">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="m_b_center">
        <h3><i class="el-icon-download"/>文件下载</h3>
        <el-table
          :data="orderFileData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column label="运单号" prop="clientNo"></el-table-column>
          <el-table-column label="文件类型">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                style="margin-left:10px"
                @click="file(scope.row)"
              >{{ scope.row.typeTxt }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="订单日期">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="m_b_right" style="margin-right:0">
        <h3><i class="el-icon-bell"/>物流通知</h3>
        <el-table
          :data="logstatusData"
          class="table"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width:100%;margin-top:20px;"
          max-height="400"
        >
          <el-table-column label="运单号">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="最新物流" prop="status"></el-table-column>
          <el-table-column label="发生时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">
                {{
                scope.row.createTime | dateformat('YYYY-MM-DD')
                }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-dialog 
        title="实名认证"
        :visible.sync="autheDialogVisible"
        :close-on-click-modal="false"
        width="600px"
        class="auth-dialog">
        <div class="auth-content">
          <el-alert
            title="请上传身份证正反面照片"
            type="info"
            :closable="false"
            show-icon
            style="margin-bottom: 20px;">
          </el-alert>
          <el-upload 
            style="text-align:center"
            class="upload-demo"
            :action="uploadUrl + '/file/upload'"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-success="businessSuccess"
            :before-upload="beforeUpload"
            :limit="5"
            name="upload"
            ref="uploadDeliveryImgRef">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过2MB
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="autheDialogVisible = false">取消</el-button>
          <el-button 
            type="primary" 
            @click="waterSingle" 
            :loading="submitting"
            :disabled="deliveryImg.length === 0">
            提交认证
          </el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisible" title="图片预览">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <el-dialog
        :visible.sync="msgDialogVisible"
        :close-on-click-modal="false"
        width="342px"
        :modal-append-to-body = "false">
        <Wxlogin
          v-if="wxConfigAvailable"
          id="wxLoginForm"
          :appid="appid"
          :scope="scope"
          :redirect_uri="redirect_uri"
        ></Wxlogin>
        <div v-else class="wx-config-error">
          微信功能暂不可用，请联系管理员配置
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
//引入api
import httpApi from "../http/api";

import Wxlogin from "vue-wxlogin"
export default {
  name: "Personal",
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    return {
      orderData: [], //问题件
      balanceData: {}, //用户余额
      staticsData: {}, //业务统计
      abnormalData: [], //问题件
      orderFileData: [], //下载文件
      logstatusData: [], //用户通知
      userData: {}, //用户信息
      autheDialogVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      deliveryImg: [],
      fileList: [],
      appid: "", // 应用唯一标识，在微信开放平台提交应用审核通过后获得
      scope: "snsapi_login", // 应用授权作用域，网页应用目前仅填写snsapi_login即可
      redirect_uri: "", // 重定向地址 （回调地址）
      msgDialogVisible: false,
      code: "",
      wxConfigAvailable: false, // 微信配置是否可用
      loading: false, // 页面加载状态
      submitting: false, // 提交按钮loading状态
      uploadUrl: "" // 上传地址
    };
  },
  methods: {
    //点击订单号跳往详情
    toOrderdeta(orderNo) {
      this.$router.push("/orderdetails/" + orderNo);
    },
    //文件下载
    file(row) {
      window.open(row.url);
    },
    //修改账号
    toAccount() {
      this.$router.push("/account");
    },
    toPassword() {
      this.$router.push("/changepass");
    },
    //用户余额
    balanceM() {
      this.loading = true;
      httpApi.balanceM()
        .then(res => {
          if (res.data.code === "ok") {
            this.balanceData = res.data.data || {};
            if (this.balanceData.credit === null || this.balanceData.credit === "") {
              this.balanceData.credit = 0;
              this.balanceData.remainingCredit = 0;
            } else {
              this.balanceData.remainingCredit = (this.balanceData.credit * 1000 - this.balanceData.obligations * 1000) / 1000;
              if (this.balanceData.remainingCredit < 0) {
                this.userData.statusTxt = "扣货中";
              }
            }
          } else {
            this.$message.error(res.data.message || "获取余额信息失败");
          }
        })
        .catch(error => {
          console.error("获取余额信息异常:", error);
          this.$message.error("获取余额信息失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //业务统计
    staticsM() {
      this.loading = true;
      httpApi.staticsM()
        .then(res => {
          if (res.data.code === "ok") {
            this.staticsData = res.data.data || {};
          } else {
            this.$message.error(res.data.message || "获取业务统计失败");
          }
        })
        .catch(error => {
          console.error("获取业务统计异常:", error);
          this.$message.error("获取业务统计失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //问题件
    abnormal() {
      this.loading = true;
      httpApi.abnormal()
        .then(res => {
          if (res.data.code === "ok") {
            this.abnormalData = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取问题件失败");
          }
        })
        .catch(error => {
          console.error("获取问题件异常:", error);
          this.$message.error("获取问题件失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //文件下载
    orderFile() {
      this.loading = true;
      httpApi.orderFile()
        .then(res => {
          if (res.data.code === "ok") {
            this.orderFileData = (res.data.data && res.data.data.rows) || [];
          } else {
            this.$message.error(res.data.message || "获取文件列表失败");
          }
        })
        .catch(error => {
          console.error("获取文件列表异常:", error);
          this.$message.error("获取文件列表失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //实名认证弹框
    autheDialog(){
      this.autheDialogVisible = true;
    },
    //用户通知
    logstatus() {
      this.loading = true;
      httpApi.logstatus()
        .then(res => {
          if (res.data.code === "ok") {
            this.logstatusData = res.data.data || [];
          } else {
            this.$message.error(res.data.message || "获取通知信息失败");
          }
        })
        .catch(error => {
          console.error("获取通知信息异常:", error);
          this.$message.error("获取通知信息失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //查询客户信息
    getUser() {
      this.loading = true;
      httpApi.getUser()
        .then(res => {
          if (res.data.code === "ok") {
            this.userData = res.data.data || {};
            if (this.userData.findUserFileResponseList && Array.isArray(this.userData.findUserFileResponseList)) {
              this.userData.findUserFileResponseList.forEach(v => {
                this.fileList.push({ name: v.name, url: v.url });
              });
            }
            //运行微信绑定解绑，重定向回来无法获取到用户的微信昵称，就无法判断是绑定还是解绑，会一直进行绑定程序
            this.bindingWeixin();
          } else {
            this.$message.error(res.data.message || "获取用户信息失败");
          }
        })
        .catch(error => {
          console.error("获取用户信息异常:", error);
          this.$message.error("获取用户信息失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePictureCardPreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    businessSuccess(file, fileList){
      let data = fileList.response.data;
      this.deliveryImg.push(data.url);
    },
    beforeUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/bmp'];
      const isAllowed = allowedTypes.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isAllowed) {
        this.$message.error('只能上传 jpeg、jpg、png、bmp 格式的图片');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isAllowed && isLt2M;
    },
    waterSingle() {
      if (this.deliveryImg.length === 0) {
        this.$message.warning("请先上传认证图片");
        return;
      }
      
      this.submitting = true;
      httpApi
        .userAuthe({
          params: {
            username: this.userData.id,
            imgUrl: this.deliveryImg.join(',')
          }
        })
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("认证成功！");
            this.autheDialogVisible = false;
            this.$router.go(0);
          } else {
            this.$message.error(res.data.message || "认证失败");
          }
        })
        .catch(error => {
          console.error("提交认证异常:", error);
          this.$message.error("提交认证失败，请稍后重试");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    initWeixin() {
      httpApi
        .listParams({
          params: {
            type: "sys_weixin",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code === "ok" && res.data.data && res.data.data.length > 0) {
            const weixinConfig = res.data.data[0];
            if (weixinConfig.appid && weixinConfig.encodeUrl) {
              this.redirect_uri = encodeURI("http://" + weixinConfig.encodeUrl + "/personal");
              this.appid = weixinConfig.appid;
              this.wxConfigAvailable = true;
            } else {
              this.wxConfigAvailable = false;
              console.warn("微信配置不完整，缺少 appid 或 encodeUrl");
            }
          } else {
            this.wxConfigAvailable = false;
            console.warn("获取微信配置失败或无数据");
          }
        })
        .catch(error => {
          this.wxConfigAvailable = false;
          console.error("获取微信配置异常:", error);
        });
    },
    openWxDialog() {
      if (!this.wxConfigAvailable) {
        this.$message.warning("微信功能暂不可用，请联系管理员配置");
        return;
      }
      this.msgDialogVisible = true;
    },
    bindingWeixin() {
      if (!this.wxConfigAvailable) {
        console.warn("微信配置不可用，跳过微信绑定/解绑");
        return;
      }
      
      if (this.code && this.code.trim()) {
        if (this.userData.nickname) {
          // 解绑
          httpApi
            .unbindWeixin({
              params: {
                code: this.code
              }
            })
            .then(res => {
              if (res.data.code === "ok") {
                this.$message.success("解绑成功！");
                // 刷新当前页面而不是跳转
                this.$router.go(0);
              } else {
                this.$message.error(res.data.message || "解绑失败");
              }
            })
            .catch(error => {
              console.error("微信解绑异常:", error);
              this.$message.error("解绑失败，请稍后重试");
            });
        } else {
          // 绑定
          httpApi
            .bindingWeixin({
              params: {
                code: this.code
              }
            })
            .then(res => {
              if (res.data.code === "ok") {
                this.$message.success("绑定成功！");
                // 刷新当前页面而不是跳转
                this.$router.go(0);
              } else {
                this.$message.error(res.data.message || "绑定失败");
              }
            })
            .catch(error => {
              console.error("微信绑定异常:", error);
              this.$message.error("绑定失败，请稍后重试");
            });
        }
      }
    },
  },
  created() {
    this.code = this.$route.query.code;
    this.uploadUrl = process.env.VUE_APP_MANAGER_API || '';
    this.initWeixin();
    this.getUser();
    this.staticsM();
    this.abnormal();
    this.orderFile();
    this.logstatus();
    this.balanceM();
  }
};
</script>

<style lang="less" scoped>
.main_top {
  width: 100%;
  height: 235px;
  display: flex;
  flex-wrap: wrap;
}
.main_btn {
  width: 100%;
  min-height: 60vh;
  display: flex;
  flex-wrap: wrap;
}
.main_top,
.main_btn {
  display: flex;
  .m_t_left,
  .m_t_center,
  .m_t_right,
  .m_b_left,
  .m_b_center,
  .m_b_right {
    flex-shrink: 0;
    margin-right: 24px;
    h3 {
      text-align: left;
      font-size: 14px;
      margin-top: 15px;
      i {
        font-size: 14px;
        font-weight: bold;
        margin-right: 4px;
      }
    }
  }
}
.main_top .el-card {
  margin-top: 0;
}
.main_top {
  .m_t_left {
    flex: 1;
    min-width: 450px;
    .m_box {
      margin-top: 20px;
      float: left;
      width: 33%;
      height: 40%;
      margin-bottom: 15px;
      position: relative;
      .m-img {
        width: 50%;
        float: left;
        img {
          display: inline-block;
          width: 50px;
          height: 50px;
        }
      }
      .m_box_cent {
        width: 50%;
        float: left;
        h4 {
          margin-top: 5px;
        }
        p {
          font-size: 18px;
          margin-top: 5px;
        }
      }
    }
  }

  .m_t_center {
    flex: 1;
    min-width: 450px;
    .m_title {
      margin-top: 10px;
      height: 60px;
      line-height: 50px;
      img {
        float: left;
        width: 50px;
        height: 50px;
      }
      h2 {
        float: left;
      }
      button {
        margin-left: 20px;
      }
    }
    .m_btn {
      width: 100%;
      height: 100px;
      margin-top: 10px;
      li {
        list-style: none;
        width: 45%;
        float: left;
        height: 30px;
        line-height: 30px;
        text-align: left;
        b {
          display: inline-block;
          width: 60px;
        }
      }
    }
  }
  .m_t_right {
    flex: 1;
    min-width: 300px;
    .m-btn {
      margin-top: 25px;
      li {
        list-style: none;
        text-align: left;
        b {
          width: 60px;
          display: inline-block;
          line-height: 30px;
          text-align: right;
        }
        span {
          font-size: 18px;
          display: inline-block;
          line-height: 30px;
          margin-left: 5px;
        }
      }
    }
  }
}
.main_btn {
  .m_b_left {
    flex: 1;
    min-width: 450px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
  .m_b_center {
    flex: 1;
    min-width: 450px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
  .m_b_right {
    flex: 1;
    min-width: 300px;
    .table {
      /deep/th > .cell {
        text-align: center !important;
        font-size: 12px;
      }
    }
  }
}
/deep/.el-table .cell {
  text-align: center;
}

// 平板适配（1024px-1400px：业务统计一行3个）
@media (max-width: 1400px) and (min-width: 1025px) {
  .main_top {
    .m_t_left {
      min-width: 350px;
    }
    .m_t_center {
      min-width: 350px;
    }
    .m_t_right {
      min-width: 250px;
    }
  }
  .main_btn {
    .m_b_left {
      min-width: 350px;
    }
    .m_b_center {
      min-width: 350px;
    }
    .m_b_right {
      min-width: 250px;
    }
  }
}

// 平板适配（1024px及以下：业务统计一行3个，微信昵称溢出处理）
@media (max-width: 1024px) and (min-width: 901px) {
  .main_top {
    height: auto;
    .m_t_left,
    .m_t_center,
    .m_t_right {
      width: 100%;
      margin-right: 0;
      margin-bottom: 24px;
    }
    .m_t_left {
      min-width: auto;
      // 业务统计版块优化：保持一行3个，调整内部尺寸防止重叠
      &::after {
        content: "";
        display: table;
        clear: both;
      }
      .m_box {
        width: 33.33%;
        min-width: 100px;
        height: auto;
        min-height: 75px;
        float: left;
        padding: 0 3px;
        box-sizing: border-box;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        .m-img {
          width: 30px;
          height: 30px;
          float: none;
          flex-shrink: 0;
          img {
            width: 25px;
            height: 25px;
          }
        }
        .m_box_cent {
          width: calc(100% - 30px);
          float: none;
          padding-left: 5px;
          box-sizing: border-box;
          h4 {
            margin: 0 0 3px 0;
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          p {
            font-size: 13px;
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .m_t_center {
      min-width: auto;
      // 账号信息版块优化：解决微信昵称过长换行重叠问题
      .m_btn {
        li {
          b {
            width: 70px;
            flex-shrink: 0;
          }
          // 微信昵称等文本添加溢出处理
          span {
            max-width: calc(100% - 75px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
    .m_t_right {
      min-width: auto;
    }
  }
  .main_btn {
    height: auto;
    // 确保在 main_top 下方，避免重叠
    margin-top: 20px;
    .m_b_left,
    .m_b_center,
    .m_b_right {
      width: 100%;
      margin-right: 0;
      margin-bottom: 24px;
    }
    .m_b_left {
      min-width: auto;
    }
    .m_b_center {
      min-width: auto;
    }
    .m_b_right {
      min-width: auto;
    }
  }
}

// iPad Air 横屏适配（隐藏用户余额）
@media (max-width: 1180px) and (min-height: 800px) {
  .main_top {
    .m_t_right {
      display: none;
    }
  }
}

// 平板适配（768px-900px：业务统计2列布局）
@media (max-width: 900px) and (min-width: 769px) {
  .main_top {
    .m_t_left {
      .m_box {
        width: 50%;
        min-width: 140px;
      }
    }
    .m_t_center {
      .m_btn {
        li {
          b {
            width: 70px;
          }
          span {
            max-width: calc(100% - 75px);
          }
        }
      }
    }
  }
}

// 认证弹框样式
.auth-dialog {
  .auth-content {
    margin: 20px 0;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .wx-config-error {
    text-align: center;
    color: #909399;
    font-size: 14px;
    padding: 20px;
  }
}

// 上传组件样式优化
.upload-demo {
  width: 100%;
}

/deep/.el-dialog__body {
  padding: 20px;
}

// 空数据提示
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 20px;
  font-size: 14px;
}
</style>